import { doPostRequestV1 } from "./ApiService";
import { baseHeaders } from "./Headers";

export default function getAllPlans(): Promise<any> {
  const url = `/query?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-app-version": process.env.VUE_APP_X_APP_VERSION,
    "x-uid": process.env.VUE_APP_X_UID,
  };
  const payload = {
    resources: [
      {
        resource: "catalogValidity",
        with: {
          filter: {
            customer: {
              tags: [
                {
                  tag: "join_teste_ab",
                },
                {
                  tag: "join",
                },
              ],
            },
            exclusiveProfile: true,
            mergeCatalogs: true,
          },
        },
      },
    ],
  };
  return doPostRequestV1<any>(url, payload, headers);
}
